<script>
import Cookies from "js-cookie"

export default {
  data () {
    return {
      showFloat: true,
      show: false,
      checked: false,
      necessary: false,
      noNecessary: false
    }
  },
  mounted () {
    this.showFloat = Cookies.get("CookieConsent")
  },
  methods: {
    setCookie(value) {
      Cookies.set("CookieConsent", value, { expires: 365 });
      this.show = false
      this.showFloat = true
    },
    check(status) {
      this.checked = status
    },
    setNecessary() {
      this.necessary = !this.necessary
    },
    setNonecessary() {
      this.noNecessary = !this.noNecessary
    }
  }
}
</script>
<template>
  <div>
    <div class="float-blk" v-show="!showFloat">
      <p class="float-text" >
        We use cookies to personalise content and ads, to provide social media features and to analvse our traffic. We also share information about vour use of our site with our social media, advertising and analytics partners who may combine it with other information that you've provided to them or that they've collected from your use of their services. Check 
        <router-link to="/privacy">Privacy policy</router-link>
      </p>
      <div class="btn-list">
        <div class="btn" @click="show = true">
          Cookie Settings
        </div>
        <div class="btn" @click="setCookie(true)">
          Accept All
        </div>
        <div class="btn" @click="setCookie(false)">
          Reject All
        </div>
      </div>
    </div>
    <div class="cookie-modal" v-if="show">
      <div class="modal-content">
        <img class="img" src="@/assets/img/close.png" alt="" @click="show = false">
        <h5 class="title">Privacy Overview</h5>
        <p class="info">
          This website uses cookies to improve your experience while you navigate through the website. Out of these,
          the cookies that are categorized as necessary are stored on your browser as they are essential for the
          working of basic functionalities of the website. We also use third-party cookies that help us analyze and
          understand how you use this website. These cookies will be stored in your browser only with your consent.
          You also have the option to opt-out of these cookies. But opting out of some of these cookies may affect
          your browsing experience.
        </p>
        <div class="cell" @click="setNecessary">
          <span class="left">Necessary</span>
          <span>Always Enabled</span>
        </div>
        <p v-show="necessary" class="cell-info">
          Necessary cookies are absolutely essential for the website to function properly. This category only
          includes cookies that ensures basic functionalities and security features of the website. These cookies
          do not store any personal information.
        </p>
        <div class="cell" @click="setNonecessary">
          <span class="left">Non-necessary</span>
          <div class="right">
            <span class="status">{{ checked ? "Enabled" : "Disabled" }}</span>
            <div class="switch">
              <div v-if="!checked" class="label" @click.stop="check(true)"></div>
              <div v-else class="label-red" @click.stop="check(false)"></div>
            </div>
          </div>
        </div>
        <p v-show="noNecessary" class="cell-info">
          Any cookies that may not be particularly necessary for the website to function and is used specifically
          to collect user personal data via analytics, ads, other embedded contents are termed as non-necessary
          cookies. It is mandatory to procure user consent prior to running these cookies on your website.
        </p>
        <div class="modal-button">
          <div class="button" @click="setCookie(true)">SAVE & ACCEPT</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang='scss'>
@import '@/styles/public.scss';

.float-blk{
  box-sizing: border-box;
  width: 100%;
  height: 200px;
  background-color: #111111;
  padding: 30px 120px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  .float-text{
    font-size: 15px;
    line-height: 24px;
    color: #FFFFFF;
    flex: 1;
  }
  .btn-list {
    display: flex;
    margin-top: 20px;
  }
  .btn{
    height: 44px;
    line-height: 44px;
    border-radius: 100px;
    background: #FFF;
    font-size: 16px;
    text-align: center;
    color: #1C58F5;
    font-weight: bold;
    padding: 0px 40px;
    margin-right: 19px;
    cursor: pointer;
    &:nth-child(2) {
      background: #1C58F5;
      color: #fff;
    }
  }
  a{
    color: #1C58F5;
  }
}

.cookie-modal {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 30px;
  z-index: 10000;
  max-height: 80%;
  overflow-y: auto;
  width: 650px;
  .img {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    width: 24px;
    height: 24px;
  }
  .title {
    font-size: 18px;
    font-weight: 400;
    margin: 10px 0;
  }
  .info {
    font-size: 16px;
    line-height: 26px;
    color: #000;
    margin-bottom: 20px;
  }
  .cell {
    border-radius: 5px;
    padding: 12px 15px;
    cursor: pointer;
    transition: background-color 0.2s ease-out 0.3s, color 0.2s ease-out 0s;
    background-color: #f2f2f2;
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    margin-bottom: 5px;
    .left {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #000;
      text-transform: capitalize;
      &:before {
        width: 7px;
        height: 7px;
        border-right: 1px solid #4a6e78;
        border-bottom: 1px solid #4a6e78;
        content: " ";
        transform: rotate(-45deg);
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
        margin-right: 10px;
      }
    }
  }
  .cell-info {
    padding: 5px 20px 10px 20px;
    font-size: 14px;
    line-height: 20px;
  }
  .right {
    display: flex;
    justify-content: flex-end;
  }
  .status {
    margin: 2px 10px 0 0;
  }
  .switch {
    display: inline-block;
    position: relative;
    min-height: 1px;
    padding-left: 38px;
    font-size: 14px;
  }
  .label {
    border-radius: 34px;
    font-size: 0;
    background-color: #e3e1e8;
    height: 20px;
    width: 38px;
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: .4s;
    &:before {
      border-radius: 50%;
      background-color: #fff;
      bottom: 2px;
      content: "";
      height: 15px;
      left: 3px;
      position: absolute;
      transition: .4s;
      width: 15px;
    }
  }
  .label-red {
    background: #1C58F5;
    height: 20px;
    width: 38px;
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: 0.4s;
    border-radius: 34px;
    font-size: 0;
    &:before {
      transform: translateX(18px);
      background-color: #fff;
      bottom: 2px;
      content: "";
      height: 15px;
      left: 3px;
      position: absolute;
      transition: 0.4s;
      width: 15px;
      border-radius: 50%;
    }
  }
  .modal-button {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    .button {
      background: #1C58F5;
      cursor: pointer;
      font-size: 16px;
      display: inline-block;
      font-weight: 500;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border: 1px solid transparent;
      padding: 12px;
      color: #fff;
    }
  }
}

</style>